import "chartjs-adapter-moment";
import "utils/sentry";
import "app/shared";
import { createRoot } from "react-dom/client";
import { injectTemplateScripts } from "app/shared/utils";
import "./styles/app.scss";
import "react-circular-progressbar/dist/styles.css";
import "antd/dist/reset.css";
import store from "app/store";
import { Provider } from "react-redux";
import App from "App";
import { BrowserRouter as Router } from "react-router-dom";
import IntercomProvider from "analytics/IntercomProvider";
import { SharedProvider } from "@shared/app/SharedProvider";
import { ResizeObserver as Polyfill } from "@juggle/resize-observer";
import SocketProvider from "features/socket/SocketProvider";

window.ResizeObserver = window.ResizeObserver || Polyfill;

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <SharedProvider store={store}>
      <SocketProvider>
        <IntercomProvider>
          <Router>
            <App />
          </Router>
        </IntercomProvider>
      </SocketProvider>
    </SharedProvider>
  </Provider>
);

injectTemplateScripts(`${import.meta.env.VITE_APP_ENVIRONMENT}`);
